import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { SnackService } from 'src/app/services/snack.service';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { AppSnackComponent } from '../../../shared/components/snacks/snack.component';
import { AppSnackBaseComponent } from '../../../shared/components/snacks/snack-base.component';

export interface VisualApiExportCopiedSnackData {
  format: string;
};

@Component({
  selector: 'app-visual-api-export__copied-snack',
  template: `
    <div class="text-center">
      <div class="fs-16">
        <strong>{{data.format}}</strong><span> link has been <strong>Copied</strong> to </span><strong>Clipboard</strong>
      </div>
    </div>`,
  encapsulation: ViewEncapsulation.None,
  host: { 'class': 'mat-simple-snackbar' },
  standalone: false
})
export class VisualApiExportCopiedSnack extends AppSnackBaseComponent {
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    snackBarRef: MatSnackBarRef<VisualApiExportCopiedSnack>,
    @Inject(MAT_SNACK_BAR_DATA) public data: VisualApiExportCopiedSnackData) {
    super(changeDetectorRef, snackBarRef);
  }
};
